import React from "react";
import PropTypes from "prop-types";
import Col from "../Col";

export const MapLoader = () => (
    <div>
        <div style={{
            zIndex: '1000',
            position: 'absolute',
            top: '30px',
            right: '10px'
        }}>
            <div className="c-reactloader dark status o-col-2"><i className="loader"></i></div>
        </div>
    </div>
);

const legendePanelStyle = {
    zIndex: '1000',
    position: 'absolute',
    top: '10px',
    right: '10px',
    backgroundColor: 'white',
    padding: '12px',
    width: '160px',
    boxShadow: '-4px 4px 18px #4d4a4a',
    borderRadius: '5px',
    pointerEvents: 'auto'
};

export const Legende = ({ onMouseOut, customRows }) => (
    <div onMouseOut={onMouseOut}>
        <div style={legendePanelStyle}>
            <Col size={12}>
                {customRows}
            </Col>
        </div>
    </div>
);

Legende.propTypes = {
    onMouseOut: PropTypes.func,
    customRows: PropTypes.array
};

export const MapManual = ({ onMouseOut, children }) => (
    <div onMouseOut={onMouseOut}>
        <div className="map-manual">
            <Col size={12}>
                {children}
            </Col>
        </div>
    </div>
);

MapManual.propTypes = {
    onMouseOut: PropTypes.func,
    children: PropTypes.node
};
